<template>
  <div id="contenedor-main-listado-insumos-contrato">
    <template v-if="!$vuetify.breakpoint.mobile">
      <desktop :listado="listado"></desktop>
    </template>
    <template v-else>
      <desktop :listado="listado"></desktop>
    </template>
  </div>
</template>

<script>
import Desktop from './Desktop.vue';
// import Mobile from './Mobile.vue';

export default {
  name: 'MainListadoFrente',
  props: {
    listado: {
      type: Array,
      required: true,
    },
  },
  components: {
    Desktop,
    // Mobile,
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss">
</style>
